// team/shared/components/notification/TeamUpgradeSnackBar.js
import React from 'react';
import { Snackbar, Alert, IconButton, Button } from '@mui/material';
import { CloseIcon } from 'icons/materialIcons';

const TeamUpgradeSnackBar = ({
    open,
    handleClose,
    handleSubscribe,
    message = 'Upgrade to Pro, Pro Plus, or Teams to edit' // Default message with option to override
}) => {
    return (
        <Snackbar
            open={open}
            autoHideDuration={5000}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
            <Alert
                onClose={handleClose}
                severity="info"
                variant="filled"
                sx={{
                    backgroundColor: '#2294f2',
                    padding: '15px 15px',
                    color: '#fff',
                    fontSize: '0.8rem',
                    fontWeight: 600,
                }}
                action={
                    <>
                        {/* "Upgrade Now" Button */}
                        <Button
                            onClick={handleSubscribe}
                            sx={{
                                color: '#000',
                                backgroundColor: '#fff',
                                borderRadius: '20px',
                                padding: '5px 10px',
                                marginRight: '5px',
                                fontSize: '0.7rem',
                                fontWeight: 600,
                                textTransform: 'none',
                                '&:hover': {
                                    backgroundColor: '#f0f0f0',
                                },
                            }}
                        >
                            Upgrade now
                        </Button>

                        {/* Close Icon */}
                        <IconButton
                            size="small"
                            color="inherit"
                            onClick={handleClose}
                        >
                            <CloseIcon fontSize='0.7rem' />
                        </IconButton>
                    </>
                }
            >
                {message}
            </Alert>
        </Snackbar>
    );
};

export default TeamUpgradeSnackBar;